import { store } from '@checkout/store/store';
import api from "@checkout/services/api";
import router from "@checkout/router";
import localStorage from "@checkout/services/storage";
import PaymentModal from "@checkout/components/Partials/PaymentModal";
import SingleStep from "@checkout/components/Partials/SingleStep.vue";
import StepWrapper from '@checkout/components/Partials/StepWrapper.vue';
import storage from "@checkout/services/storage";
import { transformErrors } from '@checkout/services/errors';

export default {
    name: 'CheckoutStep6',

    mounted() {
        this.prepareStep();
    },

    data() {
        return {
            showPaymentModal: false,
            formActionUrl: window.location.origin + '/checkout/6',
            srcScript: process.env.MIX_PAYUNITY_URL,
        };
    },

    components: {
        PaymentModal,
        SingleStep,
        StepWrapper,        
    },

    methods: {
        prepareStep() {
            api.get('/public-api/prepare/6/'+ localStorage.get('page-step', true))
                .then(() => {} /*this.getPaymentStatus()*/)
                .catch((error) => {
                    this.$swal(this.$i18nApi.t('messages.error'));
                    if (error.response.data.hasOwnProperty('page')) {
                        router.push('/checkout/'+ error.response.data.page)
                    } else {
                        router.push('/checkout/1')
                    }
                })
        },
/*
        getPaymentStatus() {
            store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE');

            api.get(`/public-api/transaction-status?checkoutId=${this.$route.query.resourcePath}`)
                .then((response) => {
                    if (response.data.status.validPayment) {
                        this.createOrder()
                    } else {
                        this.$swal({
                            title: this.$i18nApi.t('checkout9.payunity.'+response.data.status.transactionStatusCodeRaw),
                            icon: 'error',
                            buttons: {
                                confirm: {
                                    value: 0
                                }
                            }
                        }).then(() => {
                            store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
                            this.showPayment()
                        });
                    }
                })
                .catch(() => {
                    this.$swal(this.$i18nApi.t('messages.error'));
                    router.push('/checkout/4')
                })
        },
*/
        showPayment() {
            api.post('/public-api/prepare-transaction-request-js')
                .then((response) => {
                    window.location.href = response.data.redirectUrl;
                    // const scriptEl = document.createElement('script');
                    // scriptEl.setAttribute('src',
                    //     `${this.srcScript}${response.data.checkoutId}`);
                    // this.$refs.paymentScriptWrapper.appendChild(scriptEl);
                    // this.showPaymentModal = true;
                }).catch(error => {
                this.$swal(this.$i18nApi.t('messages.error'));
                if (error.response.data.hasOwnProperty('amount')) {
                    this.createOrder();
                }

                if (error.response.status === 422) {
                    this.errors = transformErrors(error.response.data.errors);
                } else if (error.response.status === 406) {
                    this.errors = error.response.data.body.error_fields;
                }
            });
        },

        /**
         * Close payment modal
         */
        closeModal() {
            this.showPaymentModal = false;
        },

        createOrder() {
            store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");
            
            api.post('/public-api/create-order', {billPayed: true})
                .then(() => {
                    store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
                    router.push('/checkout/7')
                })
                .catch(() => {
                    store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
                    this.$swal(this.$i18nApi.t('messages.error'));
                })
        },
    },

    beforeRouteLeave(to, from, next) {
        if (!this.skipJumping) {
            storage.save('page-step', window.location.pathname.split('/').pop(), true);
        }
        next();
    },
}
